import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { STEPS } from "@/lib/content";

export default function HowItWorks() {
  return (
    <div className="mx-auto max-w-5xl px-6 lg:px-14 pt-8 pb-24">
      <div className="max-w-2xl">
        <div className="overline text-cobalt-500">How it works</div>
        <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black tracking-tighter leading-[0.95]">
          Four steps,<br />request to certificate.
        </h1>
        <p className="mt-5 text-lg text-muted-foreground leading-relaxed">
          The same flow every event follows — with the right approvals and access built into each stage.
        </p>
      </div>

      <div className="mt-14 relative">
        <div className="absolute left-[27px] top-4 bottom-4 w-px bg-gradient-to-b from-cobalt-500/40 via-cobalt-500/15 to-transparent hidden sm:block" />
        <div className="space-y-6">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className="relative flex gap-5 items-start"
              >
                <div className="relative z-10 shrink-0 h-14 w-14 rounded-2xl bg-gradient-to-br from-cobalt-500 to-cobalt-700 grid place-items-center text-white shadow-[0_10px_30px_rgba(0,71,255,0.35)]">
                  <Icon className="h-6 w-6" />
                </div>
                <div className="glass rounded-2xl p-5 flex-1 card-hover">
                  <div className="flex items-center gap-2">
                    <span className="text-mono text-[11px] tracking-widest uppercase text-cobalt-500">Step {s.n}</span>
                  </div>
                  <h3 className="mt-1 font-display text-2xl font-extrabold tracking-tighter">{s.title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

      <div className="mt-14 glass-strong rounded-3xl p-10 text-center relative overflow-hidden">
        <div className="absolute -top-20 -left-20 h-60 w-60 rounded-full bg-chartreuse/30 blur-3xl opacity-40" />
        <div className="relative">
          <h2 className="font-display text-3xl sm:text-4xl font-black tracking-tighter">Start with a hall request.</h2>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/login"><Button size="lg" className="rounded-full h-12 px-6">Sign in <ArrowUpRight className="ml-1.5 h-4 w-4" /></Button></Link>
            <Link to="/features"><Button variant="outline" size="lg" className="rounded-full h-12 px-6">See features</Button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}
